import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var getSearchParams = function getSearchParams(object) {
  var params = Object.entries(object).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];

    return value !== undefined && value !== null;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
  });
  return params.length > 0 ? "?".concat(params.join('&')) : '';
};
export var composeLink = function composeLink(baseUrl, parameters) {
  return baseUrl + getSearchParams(parameters);
};